import {
  createDecisionRecommendation,
  DECISION_TYPES,
  DECISION_SCOPES,
  DECISION_ENGINES,
} from "../models";

function resolveNumber(...values) {
  for (const value of values) {
    if (
      value !== null &&
      value !== undefined &&
      value !== "" &&
      Number.isFinite(Number(value))
    ) {
      return Number(value);
    }
  }

  return null;
}



export function riskFinancingRecommendationAdapter({
  portfolioData,
  decisionData,
  coverageData,
} = {}) {

  /*
   * Decision Analysis is the source of truth
   * for Risk Financing decisions.
   *
   * Structure:
   *
   * decisionData
   *    |
   *    v
   * analysis
   *    |
   *    v
   * comparison
   *    |
   *    +-- strategies[]
   *    |
   *    +-- recommended_strategy
   */

  const analysis =
    decisionData?.analysis ||
    null;


  const comparison =
    analysis?.comparison || {};


  const recommendedStrategy =
    comparison
      ?.recommended_strategy;


  if (!recommendedStrategy) {
    return [];
  }


  const strategies =
    Array.isArray(
      comparison.strategies
    )
      ? comparison.strategies
      : [];


  const alternatives =
    strategies.map(
      (strategy) => ({
        strategy:
          strategy.strategy_name,

        premium:
          resolveNumber(
            strategy.premium
          ),

        policyLimit:
          resolveNumber(
            strategy.policy_limit
          ),

        transferredLoss:
          resolveNumber(
            strategy.transferred_loss
          ),

        retainedLoss:
          resolveNumber(
            strategy.retained_loss
          ),

        tailExposure:
          resolveNumber(
            strategy.tail_exposure
          ),

        totalCost:
          resolveNumber(
            strategy.total_financing_cost
          ),

        selected:
          strategy.strategy_name ===
          recommendedStrategy.strategy_name,
      })
    );


  const executiveDecision =
   createDecisionRecommendation({

      id:
        "RF-001",

      source:
        "risk_financing",

      engine:
        DECISION_ENGINES.RISK_FINANCING,

      scope:
        DECISION_SCOPES.FINANCING,

      decisionType:
        DECISION_TYPES.TRANSFER,

      title:
        "Risk Financing Strategy",

      strategy:
        recommendedStrategy.strategy_name,

      rationale: {
        code:
          "LOWEST_EXPECTED_FINANCIAL_COST",

        description:
          "Selected through Risk Financing Decision Analysis based on expected financial cost.",
      },

      financialImpact: {
        premium:
          resolveNumber(
            recommendedStrategy.premium
          ),

        policyLimit:
          resolveNumber(
            recommendedStrategy.policy_limit
          ),

        transferredLoss:
          resolveNumber(
            recommendedStrategy
              .transferred_loss
          ),

        retainedLoss:
          resolveNumber(
            recommendedStrategy
              .retained_loss
          ),

        tailExposure:
          resolveNumber(
            recommendedStrategy
              .tail_exposure
          ),

        totalCost:
          resolveNumber(
            recommendedStrategy
              .total_financing_cost
          ),
      },

      evidence: {
        alternatives,
      },

      metadata: {
        source:
          "decision_analysis",
        sourceRecommendation: recommendedStrategy,
        businessQuestion:
          analysis?.businessQuestion ?? analysis?.business_question ??
          decisionData?.businessQuestion ?? decisionData?.business_question ?? null,
        decisionRequired:
          analysis?.decisionRequired ?? analysis?.decision_required ??
          decisionData?.decisionRequired ?? decisionData?.decision_required ?? null,
        recommendedAlternative: recommendedStrategy,
        sourceReference:
          analysis?.sourceReference ?? analysis?.source_reference ??
          decisionData?.sourceReference ?? decisionData?.source_reference ?? null,
      },

    });

  return [
    executiveDecision,
  ];

}


export default riskFinancingRecommendationAdapter;
